/*
 * @Author: Json Chen
 * @Date: 2021-06-09 09:37:06
 * @LastEditTime: 2022-01-07 16:14:10
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/TopConfigs/FloatingActionsBar/index.tsx
 */

import React from 'react';

import { store } from '@/src/store';

import ErrorProcessingHOC from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFloatingActionsBar,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFloatingActionsBarChange,
} from '../../slice';

import { validateFloatingActionsBar } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/tools';
import { getInitialFloatingBar } from '@/src/request/salesChannel/content';
import FloatingActionsBarComponent from 'src/pages/SalesChannelContentEditor/Components/FloatingActionsBar';

import { convertFloatingBarDataToRedux } from '@/src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/tools';

const FloatingActionsBar = (props) => {
  return (
    <FloatingActionsBarComponent
      {...props}
      onFloatingActionsBarChange={onFloatingActionsBarChange}
    />
  );
};

export default ErrorProcessingHOC(FloatingActionsBar, {
  getCollapseOpenStatus,
  onCollapseOpen,
  headerProps: {
    dotsFunction: [
      {
        onClick: (params, data) => {
          getInitialFloatingBar().then((response) => {
            store.dispatch(
              onFloatingActionsBarChange(
                convertFloatingBarDataToRedux(response),
              ),
            );
          });
        },
        key: 'Reset',
        body: 'Reset',
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
  id: EnumCollapseId.floatingBar,
  getContent: getFloatingActionsBar,
  title: 'Floating Actions Bar',
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, _p) => {
    const { isPrimary } = _p;
    return validateFloatingActionsBar(x, isPrimary);
  },
  getSubmitStamp,
});
